"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOptionByValue = exports.getLabel = exports.areOptionsEqual = exports.getValue = void 0;
const getValue = (option, pathToValue) => { var _a; return String((_a = (option && option[pathToValue !== null && pathToValue !== void 0 ? pathToValue : 'value'])) !== null && _a !== void 0 ? _a : ''); };
exports.getValue = getValue;
const areOptionsEqual = (a, b, pathToValue) => exports.getValue(a, pathToValue) === exports.getValue(b, pathToValue);
exports.areOptionsEqual = areOptionsEqual;
const getLabel = (option, pathToLabel) => { var _a; return String((_a = (option && option[pathToLabel !== null && pathToLabel !== void 0 ? pathToLabel : 'label'])) !== null && _a !== void 0 ? _a : ''); };
exports.getLabel = getLabel;
const getOptionByValue = (options, value, pathToValue) => options.find(option => exports.getValue(option, pathToValue) === value);
exports.getOptionByValue = getOptionByValue;
//# sourceMappingURL=getterUtils.js.map